import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { defaultAxiosInstance } from "./client"
import {
  FilterByPropertyReviewsData,
  GetAllReviewsData,
  ResponseData,
} from "./common"

export const defaultUrl = `${
  process.env.REACT_APP_BASE_API_URL || ""
}/review-and-rating`

export interface FilterByPropertyReviewsRequestData {
  pmcId: string
  pageNo: number
  keyword: string
  noOfRecords: number
}

export interface FilterByPropertyReviewsRequest
  extends Partial<AxiosRequestConfig> {
  params: FilterByPropertyReviewsRequestData
}

export interface FilterByPropertyReviewsResponseData extends ResponseData {
  data: FilterByPropertyReviewsData
}

export interface FilterByPropertyReviewsResponse extends AxiosResponse {
  data: FilterByPropertyReviewsResponseData
}

export function getFilterByPropertyReviews(
  {
    params,
    method = "get",
    url = `${defaultUrl}/properties/all`,
    ...config
  }: FilterByPropertyReviewsRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<FilterByPropertyReviewsResponse> {
  return axiosInstance({
    params,
    method,
    url,
    ...config,
  }) as Promise<FilterByPropertyReviewsResponse>
}

export interface GetAllReviewsRequestData {
  pmcId: string
  rating: number
  reviewsBy: string
  propertyId: string
  pageNo: number
  noOfRecords: number
}

export interface GetAllReviewsRequest extends Partial<AxiosRequestConfig> {
  params: GetAllReviewsRequestData
}

export interface GetAllReviewsResponseData extends ResponseData {
  data: GetAllReviewsData
}

export interface GetAllReviewsResponse extends AxiosResponse {
  data: GetAllReviewsResponseData
}

export function getAllReviews(
  {
    params,
    method = "get",
    url = `${defaultUrl}/all`,
    ...config
  }: GetAllReviewsRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<GetAllReviewsResponse> {
  return axiosInstance({
    params,
    method,
    url,
    ...config,
  }) as Promise<GetAllReviewsResponse>
}

export interface ReviewReplyRequestData {
  authorName: string
  bookingNumber: string
  propertyId: string
  message: string
}
export interface ReviewReplyRequest extends Partial<AxiosRequestConfig> {
  params: ReviewReplyRequestData
}
export interface ReviewReplyResponseData extends ResponseData {
  data: {
    message: string
  }
}

export interface ReviewReplyResponse extends AxiosResponse {
  data: ReviewReplyResponseData
}

export function reviewReply(
  {
    params,
    method = "post",
    url = `${defaultUrl}/review-reply`,
    ...config
  }: ReviewReplyRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<ReviewReplyResponse> {
  return axiosInstance({
    data: params,
    method,
    url,
    ...config,
  }) as Promise<ReviewReplyResponse>
}

export interface ReviewReportRequestData {
  pmcId: string
  propertyId: string
  propertyName: string
  bookingNumber: string
  authorName: string
  review: string
  reportingReasons: string[]
  otherReason: string
}
export interface ReviewReportRequest extends Partial<AxiosRequestConfig> {
  params: ReviewReportRequestData
}
export interface ReviewReportResponseData extends ResponseData {
  data: {
    message: string
  }
}

export interface ReviewReportResponse extends AxiosResponse {
  data: ReviewReportResponseData
}

export function reviewReport(
  {
    params,
    method = "post",
    url = `${defaultUrl}/review-report`,
    ...config
  }: ReviewReportRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<ReviewReportResponse> {
  return axiosInstance({
    data: params,
    method,
    url,
    ...config,
  }) as Promise<ReviewReportResponse>
}

export interface IsUnreadReviewRequestData {
  pmcId: string
}

export interface IsUnreadReviewRequest extends Partial<AxiosRequestConfig> {
  params: IsUnreadReviewRequestData
}

export interface IsUnreadReviewResponseData extends ResponseData {
  data: {
    isWhimstayReviewUnRead: boolean
  }
}

export interface IsUnreadReviewResponse extends AxiosResponse {
  data: IsUnreadReviewResponseData
}

export function isUnreadReview(
  {
    params,
    method = "get",
    url = `${defaultUrl}/is-unread-review-by-pmc`,
    ...config
  }: IsUnreadReviewRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<IsUnreadReviewResponse> {
  return axiosInstance({
    params,
    method,
    url,
    ...config,
  }) as Promise<IsUnreadReviewResponse>
}

export interface IsMarkReviewReadRequestData {
  pmcId: string
}
export interface IsMarkReviewReadRequest extends Partial<AxiosRequestConfig> {
  params: IsMarkReviewReadRequestData
}
export interface IsMarkReviewReadResponseData extends ResponseData {
  data: boolean
}

export interface IsMarkReviewReadResponse extends AxiosResponse {
  data: IsMarkReviewReadResponseData
}

export function isMarkReviewRead(
  {
    params,
    method = "post",
    url = `${defaultUrl}/mark-review-read-by-pmc`,
    ...config
  }: IsMarkReviewReadRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<IsMarkReviewReadResponse> {
  return axiosInstance({
    params,
    method,
    url,
    ...config,
  }) as Promise<IsMarkReviewReadResponse>
}
